
<div class="container">
  <mat-toolbar color="primary">
    <p class="mat-toolbar-header-text">{{title}}</p>
  </mat-toolbar>
  
  <div class="content-container">
    <p class="bl-mat-label dialog-message">{{message}}</p>
    <div class="dialog-buttons-container">
      <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
      <button mat-button [mat-dialog-close]="true" class="rectangle-btn"  mat-raised-button color="accent">Yes</button>
      <button mat-button [mat-dialog-close]="false" class="rectangle-btn"  mat-raised-button color="accent">No</button>
  
    </div>
  </div>
  
</div>
